// libs
import { Package, PlaySquare, BarChart2, User } from "lucide-react";
import { useLocation } from "react-router-dom";

// components
import CustomLink from "../CustomLink";

// routes
import ROUTES from "../../constants/routes";

// styles
import classes from "./styles.module.css";

export default function Navigator() {
  const { pathname } = useLocation();

  const isProductsLink = pathname === ROUTES.PRODUCTS;
  const isActionsLink = pathname === ROUTES.ACTIONS;
  const isStatisticsLink = pathname === ROUTES.STATISTICS;
  const isProfileLink = pathname === ROUTES.PROFILE;

  return (
    <div className={classes.root}>
      <CustomLink className={`${classes.link} ${isProductsLink && classes.linkActive}`} route={ROUTES.PRODUCTS}>
        <Package />
        <span>Товары</span>
      </CustomLink>

      <CustomLink className={`${classes.link} ${isActionsLink && classes.linkActive}`} route={ROUTES.ACTIONS}>
        <PlaySquare />
        <span>Действия</span>
      </CustomLink>

      <CustomLink className={`${classes.link} ${isStatisticsLink && classes.linkActive}`} route={ROUTES.STATISTICS}>
        <BarChart2 />
        <span>Аналитика</span>
      </CustomLink>

      <CustomLink className={`${classes.link} ${isProfileLink && classes.linkActive}`} route={ROUTES.PROFILE}>
        <User />
        <span>Профиль</span>
      </CustomLink>
    </div>
  );
}
